<form [formGroup]="sourceEditForm">
  <div class="form-row row">
    <div class="form-group col-12">
      <label for="ic-sourceElementName"
        class="control-label required">{{'i18n.domain.import-configuration.edit.file.column-based.source-name' |
        translate}}</label>
      <input id="ic-sourceElementName" type="text" class="form-control" formControlName="sourceElementName" />
      <app-error-messages [control]="sourceEditForm.controls.sourceElementName"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-12">
      <label for="ic-sourceElementSelectionPath"
        class="control-label required">{{'i18n.domain.import-configuration.edit.file.column-based.source-selection-path'
        | translate}}</label>
      <input id="ic-sourceElementSelectionPath" type="text" class="form-control" formControlName="sourceElementSelectionPath" />
      <app-error-messages [control]="sourceEditForm.controls.sourceElementSelectionPath"></app-error-messages>
    </div>
  </div>
</form>
